export { default as CookieConsent } from "./CookieConsent";
// export type { Props as CookieConsentProps } from './CookieConsent';
